import React, { useState } from "react";
import "../styles/Faq.css";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const questions = [
    {
      question: "What if I need to cancel my lesson?",
      answer:
        "Auto DrivR School requires lessons to be cancelled at least 48 hours in advance. <br/> Late cancellations will be charged the full lesson price.",
    },
    {
      question: "What will I need to bring to my first lesson?",
      answer:
        "Just bring your provisional driving license. <br/> And if you require glasses to read number plates, please bring them with you as well.",
    },
    {
      question: "Do I need any experience before my first lesson?",
      answer: "No experience is needed; we’ll guide you from the basics.",
    },
    {
      question: "Are weekend lessons available?",
      answer: "Yes, we offer lessons on weekends to accommodate your schedule.",
    },
  ];

  const toggleQuestion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-section" id="faq">
      <h4 className="faq-title"> FAQ </h4>
      <p className="faq-subheading"> In case you were wondering.</p>
      <div className="faq-list">
        {questions.map((item, index) => (
          <div key={index} className="faq-item">
            <button
              className="faq-question"
              onClick={() => toggleQuestion(index)}
            >
              {item.question}
              <span
                className={`faq-icon ${activeIndex === index ? "open" : ""}`}
              >
                {activeIndex === index ? "−" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <p
                className="faq-answer"
                dangerouslySetInnerHTML={{ __html: item.answer }}
              ></p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
